// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

/**
 * Environment variables.
 * @type {*} variable object.
 */
export const environment = {
  label: 'dev',
  production: false,
  appName: 'Vision Insights by Knight Frank',
  hCaptchaSiteKey: 'eed2a026-0f9e-407c-bf16-7ae25e8e6d34',
  url: 'https://dev.visioninsights.com.au',
  azure: {
    clientId: '4f037e54-a794-4dbe-aeb7-fc8454fda0be',
    authority: 'https://login.microsoftonline.com/99d6a2d9-b626-40e9-822a-688a6cda5a94',
    redirectUri: 'https://dev.visioninsights.com.au/auth',
    scope: 'api://385ffec0-2a99-4ac4-9e11-63ae3ad73c9f/access_as_user',
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
